import { __extends } from "tslib";
import { ContentElement } from './ContentElement';
var noLogs = true;
var TextElement = /** @class */ (function (_super) {
    __extends(TextElement, _super);
    function TextElement(text, elementFormat, eventMirror, textRotation) {
        if (text === void 0) { text = null; }
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this, elementFormat, eventMirror, textRotation) || this;
        _this._text = text;
        _this._rawText = text;
        noLogs || console.log('[TextElement] ' + _this._id + ' constructor', 'text', text);
        return _this;
    }
    Object.defineProperty(TextElement.prototype, "text", {
        get: function () {
            noLogs || console.log('[TextElement] ' + this._id + ' get text', this._text);
            return this._text;
        },
        // JS -> AS Bindings
        // AS -> JS Bindings
        // _text: string;
        set: function (value) {
            noLogs || console.log('[TextElement] ' + this._id + ' set text', value);
            this._text = value;
            if (this._textBlock)
                this._textBlock.setTextDataDirty();
        },
        enumerable: false,
        configurable: true
    });
    TextElement.prototype.replaceText = function (beginIndex /*int*/, endIndex /*int*/, newText) {
        noLogs || console.log('[TextElement] ' + this._id + ' replaceText', 'beginIndex', beginIndex, 'endIndex', endIndex, 'newText', newText);
        this._rawText = this._text.slice(0, beginIndex) + newText + this._text.slice(endIndex, this._text.length - 1);
        this._text = this._rawText;
        if (this._textBlock)
            this._textBlock.setTextDataDirty();
    };
    TextElement.forceNativeConstructor = true;
    TextElement.forceNativeMethods = true;
    return TextElement;
}(ContentElement));
export { TextElement };
